import {
  AssetMediaDto,
  AssetMediaStatus,
  GetAssetMediasResponseDto,
  SyncAssetMediasTagsDto,
} from "@repo/api/asset-media";
import { AmplifilesClient } from "./api-client";

export class AssetMediaApi {
  static async getTeamAssetMedias(
    teamExternalId: string,
  ): Promise<AssetMediaDto[]> {
    const response = await AmplifilesClient.instance.get(
      `/team/${teamExternalId}/media-asset`,
    );

    return AssetMediaDto.array().parse(response.data);
  }

  static async getAssetMediasByIds(
    teamExternalId: string,
    assetMediaExternalIds: string[],
    status?: AssetMediaStatus,
  ): Promise<GetAssetMediasResponseDto> {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/editor/asset-media`,
      { assetMediaExternalIds, status },
    );

    return GetAssetMediasResponseDto.parse(response.data);
  }

  static async uploadAssetMedia(
    teamExternalId: string,
    file: File,
  ): Promise<AssetMediaDto> {
    const formData = new FormData();
    formData.append("media", file);

    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/editor/asset-media-upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return AssetMediaDto.parse(response.data);
  }

  static async syncAssetMediasTags(
    teamExternalId: string,
    data: SyncAssetMediasTagsDto,
  ): Promise<AssetMediaDto[]> {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/media-assets/sync-tags`,
      data,
    );

    return AssetMediaDto.array().parse(response.data);
  }

  static async deleteAssetMedias(
    teamExternalId: string,
    externalIds: string[],
  ): Promise<{ deletedCount: number }> {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/media-assets/delete`,
      { externalIds },
    );

    return response.data;
  }
}
